import React from "react";
import Newsletter_50 from "../component/Newsletter_50";

function Newsletter_50_container() {
  return <Newsletter_50 />;
}

export default Newsletter_50_container;
